module.exports = __webpack_public_path__ + "static/media/triangle~wpequTjO.b297a4bf.svg";